import { useLabels } from 'labels/hooks/useLabels/useLabels'

export const useIsLabelReady = (label: string) => {
	const { t } = useLabels()

	return t(label) !== label
}
